module.exports = __webpack_public_path__ + "static/07-3-b575b2361b53636d33057cf5c37d6976.jpg";